import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { OrdersService } from '../../services/orders.service';
import { ReportsService } from '../../services/reports.service';
import { InventoryService } from '../../services/inventory.service';
import { CardLists, Card } from '../../classes/orders';
import { Router } from '@angular/router';
import { Ng2CompleterModule } from 'ng2-completer';
import { Location } from '@angular/common'
import { PrintService } from '../../services/print.service'
import * as FileSaver from 'file-saver';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

declare let $: any;

@Component({
  selector: 'app-brand-report',
  templateUrl: './brand-report.component.html',
  styleUrls: ['./brand-report.component.scss']
})
export class BrandReportComponent implements OnInit {

@ViewChild('salesFilter') salesmanRef: MatSelect;
	@ViewChild('branchFilter') branchesRef: MatSelect;
	@ViewChild('brandFilter') brandsRef: MatSelect;
	itemSearchRef = new FormControl('');
	orderSearchRef = new FormControl('');
	conBrRef = new UntypedFormControl('Y');
	placedFromRef = new UntypedFormControl('');
	branchRef = new UntypedFormControl('');
	brandRef = new UntypedFormControl('');
	salespersonRef = new UntypedFormControl('');
	filterresults: any = [];
	filteredItems: any = [];
	orderData: CardLists;
	customerData: any = [];
	openOrderData: any = [];
	orders: any = [];
	orderSearch: any = [];
	orderResults: any = false;
	ordersFound: any = [];
	todate = new Date();
	fromdate = new Date();
	reportCriteria = {
		fromdate: '',
		todate: '',
		brands: [],
		locs: [],
		salesperson: [],
		conbr: 'Y'
	};

	color: any = 'blue';
	config: any = [];
	pickinglink: any = '';
	filename: any = '';
	invoicelink: any = '';
	displaydetails: any = false;
	orderdetails: any = false;
	fromdateCtrl = new UntypedFormControl('');
	todateCtrl = new UntypedFormControl('');
	sending: any = false;
	branches: any = [];
	salespeople: any = [];
	brands: any = [];
	conbr: any = [{ label: 'Yes', value: 'Y' }, { label: 'No', value: 'N' }];
	exportType: string;

	ngOnInit(): void {}
	constructor(private globalSearchService: GlobalSearchService, 
				private printService: PrintService, 
				private globalsService: GlobalsService, 
				public router: Router,
				private reportsService: ReportsService, 
				private location: Location,
				private inventoryService: InventoryService) {
	
		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});

		this.globalSearchService.mesagesallowed.next(false);

		this.reportsService.getBranches().subscribe((results: any) => {
			this.branches = results;
		});

		this.reportsService.getSalesPeople().subscribe((results: any) => {
			this.salespeople = results;
		});
		
		this.inventoryService.getBrands().subscribe((results: any) => {
			this.brands = results;
		});

		const today = new Date();
		const priorDate = new Date(today.getFullYear(), today.getMonth(), 1);
		this.fromdate = priorDate;

		this.fromdateCtrl.setValue(this.fromdate)
		this.todateCtrl.setValue(this.todate)
	}
	
	public getBrandReport() {
		
		if (!this.brandRef.value.length) {
			this.showNotification('Please Select at least one Brand', 'danger', 'top', 'center');
			return;
		}
		this.sending = true;
		this.reportCriteria = {
			fromdate: this.fromdateCtrl.value.toISOString().split('T')[0],
			todate: this.todateCtrl.value.toISOString().split('T')[0],
			locs: this.branchRef.value,
			conbr: this.conBrRef.value,
			brands: this.brandRef.value,
			salesperson: this.salespersonRef.value
		};

		this.reportsService.getBrandSales(this.reportCriteria).subscribe(r => {
			this.orderResults = r;
			this.sending = false;
		})
	}
	
	
	exportPdf() {
		const d = new Date();
		const encoded: string = this.globalSearchService.base64encode(this.generateExportHTML());
		const data = {
			content: encoded,
			filename: 'Customer_sales_by_salesman_' + d.getMonth() + d.getDate() + d.getFullYear(),
			title: `Customer Sales by Salesman Ranking Report ${this.reportCriteria.fromdate} - ${this.reportCriteria.todate}`,
			subtitle: this.getSubTitle()
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	exportXls() {
		const d = new Date();
		const encoded: string = this.globalSearchService.base64encode(this.generateExportHTML());
		const data = {
			content: encoded,
			filename: 'Customer_sales_by_salesman_' + d.getMonth() + d.getDate() + d.getFullYear(),
			title: `Customer Sales by Salesman Ranking Report ${this.reportCriteria.fromdate} - ${this.reportCriteria.todate}`,
			subtitle: this.getSubTitle()
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	getBrandName(brandid: any){
	
	const matchBrand = this.brands.find(brand => brand.manufacturer_id === brandid);
	return matchBrand.name;
	}
	getSalesName(salesid: any){
	
	const matchSales = this.salespeople.find(sm => sm.salesmancode === salesid);
	return matchSales.salesmanname;
	}
	getSubTitle() {
		let out = '';
		if (this.reportCriteria.conbr == 'Y') {
			out += ' by Product Line'
		} else {
			out += ' by Brand'
		}
		if (this.reportCriteria.locs.length == this.branches.length || !this.reportCriteria.locs.length) {
			out += ' For All Locations'
		} else {
			out += ' For Locations: ';
			(this.reportCriteria.locs).forEach((loc) => {
				out += loc + ', ';
			});
			out = out.slice(0, -2);
		}
		if (this.reportCriteria.salesperson.length == this.salespeople.length || !this.reportCriteria.salesperson.length) {
			out += ' and All Salespeople'
		} else {
			out += ' and Salesperson(s): ';
			(this.reportCriteria.salesperson).forEach((person) => {
				out += this.getSalesName(person) + ', ';
			});
			out = out.slice(0, -2);
		}
		if (this.reportCriteria.brands.length == this.brands.length || !this.reportCriteria.brands.length) {
			out += ' and All Brands'
		} else {
			out += ' and Brand(s): ';
			(this.reportCriteria.brands).forEach((brand) => {
				out += this.getBrandName(brand) + ', ';
			});
			out = out.slice(0, -2);
		}
		
		return out;
	}


	back(): void {
		this.location.back()
	}

	selectAllToggle(filter_name: string) {
		let filter;
		switch (filter_name) {
		case 'salesman':
			filter = this.salesmanRef;
			break;
		case 'branch':
			filter = this.branchesRef;
			break;
		case 'brand':
			filter = this.brandRef;
			break;
		default:
			return;
		}
		const selected = filter.options.find(opt => opt.selected);
		if (selected) {
			filter.options.forEach((item: MatOption) => item.deselect());
		} else {
			filter.options.forEach((item: MatOption) => item.select());
		}
	}

	showNotification(message, type, from, align) {
		//  const type = ['','info','success','warning','danger'];
		// const color = Math.floor((Math.random() * 4) + 1);

		$.notify({
			icon: 'notifications',
			message: message

		}, {
			type: type,
			timer: 1000,
			placement: {
				from: from,
				align: align
			},
			template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
				'<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
				'<i class="material-icons" data-notify="icon">notifications</i> ' +
				'<span data-notify="title">{1}</span> ' +
				'<span data-notify="message">{2}</span>' +
				'<div class="progress" data-notify="progressbar">' +
				'<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
				'</div>' +
				'</div>'
		});
	}

	getTotalsByPline(salesmanKey: string): {
		[br: string]: number
	} {
		const totalsByPL: {
			[prodline: string]: number
		} = {};

		if (this.orderResults && this.orderResults.lines) {
			this.orderResults.lines.forEach((salesmanGroup: any) => {
				if (salesmanGroup[salesmanKey]) {
					const lines = salesmanGroup[salesmanKey].lines;
					lines.forEach((line: any) => {
						if (!totalsByPL[line.prodline]) {
							totalsByPL[line.prodline] = 0;
						}
						totalsByPL[line.prodline] += parseFloat(line.Sales);
					});
				}
			});
		}

		return totalsByPL;
	}

	generateExportHTML(): string {
		const currencyFormatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		});

		let html = `
			<table class="table" style="width: 100%">
			  <tr>
				<th style="text-align: center;">Brand</th>
				<th style="text-align: center;">Product Line</th>
				<th style="text-align: center;">Qty</th>
				<th style="text-align: center;">Sale</th>
			  </tr>
		`;

		this.orderResults.lines.forEach((salesmanGroup: any) => {
			Object.keys(salesmanGroup).forEach(salesmanKey => {
				if (salesmanKey !== 'total') {
					const lines = salesmanGroup[salesmanKey].lines;
					html += `<tr><th colspan="4" style="text-align: left;"> Brand ${salesmanKey} </th></tr>`;
					lines.forEach((line: any) => {
						html += `
				  <tr>
					<td>${line.Name}</td>
					<td>${line.prodline}</td>
					<td style="text-align: right;">${line.SalesQty}</td>
					<td style="text-align: right;">${currencyFormatter.format(line.Sales)}</td>
				  </tr>
				`;
					});
					html += `
				<tr class="salesman-rollup">
				  <th></th>
				  <th></th>
				  <th></th>
				  <th></th>
				  <th></th>
				  <th>${salesmanKey} Total: ${currencyFormatter.format(salesmanGroup[salesmanKey].total)} Count: ${salesmanGroup[salesmanKey].totalqty}</th>
				</tr>
			  `;
				}
			});
		});

		html += `
			<tr>
			  <th></th>
			  <th></th>
			  <th></th>
			  <th>Count: ${this.orderResults.totalqty}</th>
			  <th>Total: ${currencyFormatter.format(this.orderResults.total)}</th>
			</tr>
		  </table>
		`;

		return html;
	}
}
